import { Typography } from "@circle-react-shared/uikit/Typography";
import { useLevelColors } from "@circle-react/components/Leaderboard/colorHelper";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

export const LevelBadge = ({
  level,
  levelName,
  className,
}: {
  level: number;
  levelName?: string;
  className?: string;
}) => {
  const levelColors = useLevelColors(level);
  const { isCircleV4 } = useCircleV4();

  return (
    <div
      className={classNames(
        "mb-2 inline-flex items-center space-x-3 rounded-full px-3 py-1",
        levelColors.bg,
        levelColors.text,
        isCircleV4 && "rounded-md gap-2",
        className,
      )}
    >
      <Typography.LabelSm weight="semibold" color="text-inherit">
        <span className="mr-2">{t("leaderboard.trophy_emoji")}</span>
        {t("leaderboard.level_number_only", {
          level,
        })}
      </Typography.LabelSm>
      <div className={classNames("h-3 w-px rounded-md", levelColors.divider)} />
      <Typography.LabelSm weight="semibold" color="text-inherit">
        {levelName ||
          t("leaderboard.level_n", {
            level,
          })}
      </Typography.LabelSm>
    </div>
  );
};
